import React from 'react';

const EmptyState = ({ message = "No se encontraron perfiles en esta categoría" }) => {
  return (
    <div className="text-center py-20">
      <p className="text-slate-400 text-lg">{message}</p>
    </div>
  );
};

export default EmptyState;
